import { messageService } from "common/shared";
import MessageConfig from "common/shared/interfaces/message-config";

export const showSetIdontHaveThisSuccess = () => {
  messageService.success(new MessageConfig("toaster.setIdontHaveThis.success"));
};
export const showSetIdontHaveThisFail = () => {
  messageService.error(new MessageConfig("toaster.setIdontHaveThis.fail"));
};
